
import { useSelector } from "react-redux";
import { RootState } from "../store/types";

const useRedux = <T = unknown>(selector: ((state: RootState) => T)) => {
  return useSelector<RootState, T>(selector);
};

export default useRedux;
